import CountTo from "vue-count-to";
export default {
  components: {
    CountTo: CountTo
  },
  props: {
    data: Array
  }
};